import React from 'react'

import classnames from 'classnames'

import { Icon } from 'components/Icon'

import css from './Arrow.css'

type ArrowProps = {
  direction: 'left' | 'right'
  onClick?: () => void
}

const DIRECTION_CLASSES = {
  left: css.left,
  right: css.right,
}

export const Arrow = ({ direction, onClick = () => {} }: ArrowProps) => (
  <button
    className={classnames(css.arrow, DIRECTION_CLASSES[direction])}
    onClick={onClick}
    type="button"
  >
    <Icon name={`fa-chevron-${direction}`} aria-hidden="true" />
  </button>
)
